export default {

    get : {
        url: 'portal/lotto'
    },

    lottoChampion : {
        url: 'portal/lotto/champion'
    },

    start: {
        url: 'portal/lotto/start',
        method : 'put'
    },

    // params:
    // key  String  required
    getByLocation : {
        url : 'portal/lotto/location'
    }

};
